import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

type NarrowPageProps = {
  children: ReactNode;
  /** Maximum width in px. The layout content is 1200px wide; a narrow page sits centered in it. */
  maxWidth?: number;
  spacing?: number;
};

/**
 * Wrapper for pages narrower than the layout, such as a single form. It always centers itself:
 * a page that only limits its width ends up pinned to the left edge of the layout.
 */
export function NarrowPage({ children, maxWidth = 720, spacing = 4 }: NarrowPageProps) {
  return (
    <Stack spacing={spacing} sx={{ width: '100%', maxWidth, mx: 'auto' }}>
      {children}
    </Stack>
  );
}
